import 'baguettebox.js/dist/baguetteBox.min.css';
import baguetteBox from 'baguettebox.js';

window.addEventListener('load', function () {
    baguetteBox.run('.gallery');
});